export default {
    // Code flags (prefixed with `cf_`) to manually toggle calls to certain back-end features
    // that have not made their way into production yet
};
